<template>
	<div class="form-group">
	    <label :for="'input'+content.contenttype"><strong v-if="!name || name == ''">{{content.contenttype}}</strong><strong v-else>{{ name }}</strong></label> 
		<div style="position:relative">
			<tooltip v-model="showSave">Saved</tooltip>
			<textarea class="form-control mb-2" style="resize: vertical;margin-bottom:5px" :id="'input'+content.contenttype" rows="3" v-model="content.contentvalue" @blur="saveContent" @change="isChange = true"></textarea>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import Tooltip from '@/components/elements/Tooltip'

export default{
	props:['value','name'],
	data: function(){
		return {
			showSave: false,
			isChange: false,
			content: this.value
		}
	},
	components: {
		Tooltip
	},
	methods: {
		saveContent: function(){
			let vm = this
			if (vm.isChange) {
				
				api.updateConfig(vm.content,function(error,response){
							if (error) {
									console.error(error)
									return
							}

						vm.showSave = true
						vm.isChange = false
						vm.$emit('input',vm.content)
					})
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/input/InputTextarea.vue